import styled from "styled-components";
import { ContractSolicitationStatus } from "../../../../../../types/contractSolicitation";

const LINE_COLORS = {
	[ContractSolicitationStatus.Production]: "#f0b100",
	[ContractSolicitationStatus.Adjustment]: "#ff6900",
	[ContractSolicitationStatus.Validation]: "#ad46ff",
	[ContractSolicitationStatus.Creation]: "#2b7fff",
	[ContractSolicitationStatus.Finished]: "#497d00"
};

const getLineColor = (currentStatus, nextStatus) => {
	if (!nextStatus) {
		return "#e4e4e7";
	}

	const statusOrder = [
		ContractSolicitationStatus.Requested,
		ContractSolicitationStatus.Production,
		ContractSolicitationStatus.Adjustment,
		ContractSolicitationStatus.Validation,
		ContractSolicitationStatus.Creation,
		ContractSolicitationStatus.Finished
	];

	const currentIndex = statusOrder.indexOf(currentStatus);
	const nextIndex = statusOrder.indexOf(nextStatus);

	if (currentIndex >= nextIndex) {
		return LINE_COLORS[nextStatus] || "#e4e4e7";
	}

	return "#e4e4e7";
};

export const StepperContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 32px auto 0 auto;
	position: relative;
`;

export const Step = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	flex: 1;
	z-index: 1;

	&:not(:last-child)::after {
		content: "";
		position: absolute;
		top: 20px;
		left: 50%;
		width: 100%;
		height: 3px;
		background: ${({ currentStatus, nextStatus }) =>
			getLineColor(currentStatus, nextStatus)};
		z-index: -1;
		transform: translateX(0);
	}
`;

export const IconWrapper = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	background: ${({ color }) => color};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	box-sizing: border-box;
	color: white;
	font-size: 18px;
	border: 2px solid
		${({ color }) => {
			if (color === "#ffffff") {
				return "#e4e4e7";
			}

			return color;
		}};
`;

export const Label = styled.span`
	font-size: 14px;
	font-weight: 700;
	color: #31475a;
	margin-top: 16px;
`;

export const DateText = styled.span`
	font-size: 12px;
	color: #31475a;
	margin-top: 4px;
`;
